import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Protected from './pages/Protect';
import Utama from './pages/Home';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';
import Daftar from './pages/Daftar';
import VerifikasiKodeOtp from './pages/VerifikasiKodeOtp';
import SetAkun from './pages/SetAkun';
import RefKelas from './pages/refrensi/Kelas';
import RefMapel from './pages/refrensi/Mapel';
import PendidikPembelajaran from './pages/pendidik/Pembelajaran';
import PendidikSubtes from './pages/pendidik/Subtes';
import ViewEvaluasi from './pages/pendidik/ViewEvaluasi';
import IdentifikasiSekolah from './pages/IdentifikasiSekolah';
import Identifikasiaksess from './pages/Identifikasiaksess';
import FormBiodata from './pages/FormBiodata';
import PilihSemester from './pages/pilihsemester';
import FormBiodataPd from './pages/FormBiodataPd';
import DaftarKartuUjian from './pages/refrensi/DaftarKartuUjian';



import RefPendidik from './pages/refrensi/Pendidik';
import JadwalUjian from './pages/refrensi/JadwalUjian';
import HasilUjian from './pages/pendidik/HasilTex';
import DaftarTesGuru from './pages/refrensi/DaftarTesGuru';
import RefPd from './pages/refrensi/Pd';
import Sycron from './pages/refrensi/Sycron';
import { HelmetProvider } from "react-helmet-async";
import Pengaturan from './pages/refrensi/Pengaturan';
import ComingSooon from './components/ComingSoon';
import RefPembelajaan from './pages/refrensi/Pembelajaran';
import Profile from './pages/profile';
import LupaPassword from './pages/LupaPassword';
import SetLupaPassword from './pages/SetLupaPassword';
import MstTes from './pages/refrensi/MstTes';
import PelaksanaanUjian from './pages/refrensi/PelaksanaanUjian';
import HomePendidik from './pages/pendidik/HomePendidik';
import JenisAbsensi from './pages/refrensi/absensi/JenisAbsensi';
import JadwalAbsensi from './pages/refrensi/absensi/JadwalAbsensi';
import ViewMasterAbsensi from './pages/refrensi/absensi/ViewMasterAbsensi';
import MstUjianPendidik from './pages/pendidik/MstUjian';
import DaftarSubTesGuru from './pages/pendidik/Subtes';
import LaporanAbsensi from './pages/refrensi/absensi/LaporanAbsensi';
import Pengumuman from './pages/refrensi/Pengumuman';
import Setupjadwal from './pages/refrensi/jadwal/SetupJadwal';
import JadwalPembelajaran from './pages/refrensi/jadwal/JadwalPembelajaran';
import DaftarRombel from './pages/refrensi/jurnal/daftarrombel';
import ViewRombelJurnal from './pages/refrensi/jurnal/viewrombeljurnal';
import DaftarPengguna from './pages/refrensi/pengguna/dafatrpengguna';
import JenisPembayaran from './pages/bendahara/jenispembayaran';
import TagihanPembayaran from './pages/bendahara/tagihanpembayaran';
import KodeUjian from './pages/pd/kodeujian';
import RuangUjianPd from './pages/pd/ruangujianpd';
import LembarUjian from './pages/pd/lembarujian';
import HalamanTes from './pages/pendidik/HalamanTes';

const App = () => {
  
  return (
    <HelmetProvider>
        <Routes>
          {/* Rute untuk Login */}
          <Route index element={<Login />} />
          <Route path="login" element={<Login />} />
          <Route path="daftar" element={<Daftar />} />
          <Route path="daftar/verifikasiotp" element={<VerifikasiKodeOtp />} />
          <Route path="daftar/setakun" element={<SetAkun />} />
          <Route path="daftar/identifikasisekolah" element={<IdentifikasiSekolah />} />
           <Route path="daftar/identifikasiaksess" element={<Identifikasiaksess />} />
           <Route path="daftar/formbiodata" element={<FormBiodata />} />
           <Route path="daftar/formBiodatapd" element={<FormBiodataPd />} />

           

           
          <Route path="lupapassword" element={<LupaPassword />} />
          <Route path="setlupapassword" element={<SetLupaPassword />} />
          <Route path="pilihsemester" element={<PilihSemester />} />




          {/* Pendidik */}
         <Route path="pd" element={<ProtectedRoute><KodeUjian /></ProtectedRoute>} />
          <Route path="ruangujian" element={<ProtectedRoute><RuangUjianPd /></ProtectedRoute>} />
          <Route path="lembarujian" element={<ProtectedRoute><LembarUjian /></ProtectedRoute>} />

           <Route
            path="pendidik"
            element={
              <ProtectedRoute>
                <Protected />
              </ProtectedRoute>
            }
          ><Route index element={<ProtectedRoute><HomePendidik /></ProtectedRoute>} />
            <Route path="pembelajaran" element={<ProtectedRoute><PendidikPembelajaran /></ProtectedRoute>} />
            <Route path="subtes" element={<ProtectedRoute><DaftarSubTesGuru /></ProtectedRoute>} />
            <Route path="viewevaluasi" element={<ProtectedRoute><ViewEvaluasi /></ProtectedRoute>} />
            <Route path="hasilujian" element={<ProtectedRoute><HasilUjian /></ProtectedRoute>} />
            <Route path="halamantes" element={<ProtectedRoute><HalamanTes /></ProtectedRoute>} />

            <Route path="mstujianpendidik" element={<ProtectedRoute><MstUjianPendidik /></ProtectedRoute>} />

          </Route>

          {/* Admin */}
          <Route
            path="admin"
            element={
              <ProtectedRoute>
                <Protected />
              </ProtectedRoute>
            } >

            <Route path="home" element={<ProtectedRoute><PelaksanaanUjian /></ProtectedRoute>} />
            <Route index element={<Utama />} />
            <Route path="refrensi/pelaksanaanujian" element={<ProtectedRoute><PelaksanaanUjian /></ProtectedRoute>} />
            <Route path="refrensi/pengumuman" element={<ProtectedRoute><Pengumuman /></ProtectedRoute>} />
            <Route path="refrensi/kelas" element={<ProtectedRoute><RefKelas /></ProtectedRoute>} />
            <Route path="refrensi/mapel" element={<ProtectedRoute><RefMapel /></ProtectedRoute>} />
            <Route path="refrensi/pendidik" element={<ProtectedRoute><RefPendidik /></ProtectedRoute>} />
            <Route path="refrensi/jadwalujian" element={<ProtectedRoute><JadwalUjian /></ProtectedRoute>} />
            <Route path="refrensi/daftartesguru" element={<ProtectedRoute><DaftarTesGuru /></ProtectedRoute>} />
            <Route path="refrensi/pd" element={<ProtectedRoute><RefPd /></ProtectedRoute>} />
            <Route path="refrensi/sycron" element={<ProtectedRoute><Sycron /></ProtectedRoute>} />
            <Route path="refrensi/pengaturan" element={<ProtectedRoute><Pengaturan /></ProtectedRoute>} />
            <Route path="refrensi/msttes" element={<ProtectedRoute><MstTes /></ProtectedRoute>} />
            <Route path="refrensi/kartuujian" element={<ProtectedRoute><DaftarKartuUjian /></ProtectedRoute>} />


            <Route path="refrensi/pembelajaran" element={<ProtectedRoute><RefPembelajaan /></ProtectedRoute>} />

            <Route path="comingsoon" element={<ComingSooon />} />
            <Route path="profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />


            <Route path="absensi/jenisabsensi" element={<ProtectedRoute><JenisAbsensi /></ProtectedRoute>} />
            <Route path="absensi/jadwalabsensi" element={<ProtectedRoute><JadwalAbsensi /></ProtectedRoute>} />
            <Route path="absensi/laporanAbsensi" element={<ProtectedRoute><LaporanAbsensi /></ProtectedRoute>} />

            <Route path="absensi/viewmasterabsensi" element={<ProtectedRoute><ViewMasterAbsensi /></ProtectedRoute>} />
            <Route path="pengguna/daftarpengguna" element={<ProtectedRoute><DaftarPengguna /></ProtectedRoute>} />
            <Route path="bendahara/getjenispembayaran" element={<ProtectedRoute><JenisPembayaran /></ProtectedRoute>} />
            <Route path="bendahara/tagihanpembayaran" element={<ProtectedRoute><TagihanPembayaran /></ProtectedRoute>} />

            <Route path="refrensi/setupjadwal" element={<ProtectedRoute><Setupjadwal /></ProtectedRoute>} />
            <Route path="refrensi/jadwalpembelajaran" element={<ProtectedRoute><JadwalPembelajaran /></ProtectedRoute>} />
            <Route path="jurnal/jurnalrombel" element={<ProtectedRoute><DaftarRombel /></ProtectedRoute>} />
            <Route path="jurnal/virerombeljurnal" element={<ProtectedRoute><ViewRombelJurnal /></ProtectedRoute>} />



          </Route>
        </Routes>
    </HelmetProvider>
  );
  
};

export default App;
